import { ReactNode } from 'react'
import './index.scss'
import { Button } from 'antd'
export const NewYearBtn = ({ children, className = "", onClick }: { children?: ReactNode, className?: string, onClick?: () => void }) => {
    return (
        <div className={`new-year-btn ${className}`} onClick={onClick}>
            {children}
        </div>
    )
}